import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './ReportHeader.scss';
import { Link } from 'react-router-dom';

const COLLAPSE_CHARS = 100;

const ReportHeader = ({ title, description, overviewUrl }) => {
  const isLong = description && description.length > COLLAPSE_CHARS;
  const [expanded, setExpanded] = useState(false);
  const displayText = isLong && !expanded
    ? description.slice(0, COLLAPSE_CHARS).replace(/\s+\S*$/, '') + '…'
    : description;

  return (
    <div className="report-header">
      <h1 className="report-title">{title}</h1>
      <p className="report-description">
        {displayText}
        {isLong && (
          <button className="report-description-toggle" onClick={() => setExpanded(e => !e)}>
            {expanded ? ' less' : ' more'}
          </button>
        )}
      </p>
      <p className="report-overview-link">
        <Link to={overviewUrl}>View Dataset Overview →</Link>
      </p>
    </div>
  );
};

ReportHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  overviewUrl: PropTypes.string,
};

export default ReportHeader;
